import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { Component } from "react";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import * as Yup from "yup";
import { SelectField } from "./SelectField";

const CreateItemSchema = Yup.object().shape({
    author_name: Yup.string().required("Het veld 'Uw naam' is niet goed ingevuld."),
    author_email: Yup.string()
        .email("Het veld 'Uw e-mailadres' is niet goed ingevuld.")
        .required("Het veld 'Uw e-mailadres' is niet goed ingevuld."),
    item_type: Yup.string().required("Maak een keuze bij het veld 'Soort advertentie'."),
    title: Yup.string().required("Het veld 'Titel van uw advertentie' is niet goed ingevuld."),
    content: Yup.string().required("Het veld 'Omschrijving van de advertentie' is niet goed ingevuld."),
    // target_audience: Yup.number(),
    city: Yup.array()
        .min(1, "Kies minstens één plaats bij het veld 'Plaats'.")
        .required("Kies minstens één plaats bij het veld 'Plaats'.")
        .nullable()
});

export default class BulletboardCreateItemForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            recaptcha: false,
            isLoading: false
        };
        this.handleRecaptchaVerify = this.handleRecaptchaVerify.bind(this);
    }

    renderTargetAudienceOptions() {
        return this.props.targetAudience.map(option => {
            return {
                value: option.term_id,
                label: option.name
            };
        });
    }

    renderCitiesOptions() {
        return this.props.cities.map(option => {
            return {
                value: option.term_id,
                label: option.name
            };
        });
    }

    handleRecaptchaVerify() {
        this.setState({
            recaptcha: true
        });
    }

    render() {
        if (
            !this.props.cities ||
            this.props.cities.length === 0 ||
            !this.props.targetAudience ||
            this.props.targetAudience.length === 0
        ) {
            return (
                <div className="message">
                    Er zijn nog geen plaatsen/doelgroepen aangemaakt. Maak deze
                    eerst aan.
                </div>
            );
        }

        return (
            <div>
                <i>* Verplichte velden</i>

                <Formik
                    initialValues={{
                        author_name: "",
                        author_email: "",
                        author_organization: "",
                        item_type: "offer",
                        title: "",
                        content: "",
                        city: [],
                        target_audience: [null]
                    }}
                    validateOnMount={true}
                    validateOnChange={true}
                    validationSchema={CreateItemSchema}
                    onSubmit={(values, { resetForm }) => {
                        if (this.state.recaptcha) {
                            this.setState({ isLoading: true });

                            this.props
                                .onSubmit(values)
                                .then((response, errors) => {
                                    resetForm({});
                                })
                                .catch(errors => {
                                    console.error(errors);
                                })
                                .finally(() => {
                                    this.setState({ isLoading: false });
                                });
                        }
                    }}
                >
                    {({
                        errors,
                        isSubmitting,
                        handleBlur,
                        isValid,
                        touched,
                        setFieldTouched
                    }) => (
                        <Form
                            className={
                                this.state.isLoading
                                    ? "form form--loading form__wrapper"
                                    : "form form--ready form__wrapper"
                            }
                        >
                            {this.props.successMessage !== null ? (
                                <div className="message message--success">
                                    {this.props.successMessage}. Klik{" "}
                                    <a href={this.props.archivePageUrl}>hier</a>{" "}
                                    om terug te gaan naar het overzicht.
                                </div>
                            ) : null}
                            {this.props.errorMessage ? (
                                <div className="message">
                                    {this.props.errorMessage}
                                </div>
                            ) : null}

                            <div className="field__row">
                                <label
                                    htmlFor="author_name"
                                    className="field__label"
                                >
                                    Uw naam *
                                </label>
                                <div className="field__wrapper">
                                    <Field
                                        onBlur={handleBlur}
                                        className={
                                            errors.author_name &&
                                            touched.author_name
                                                ? "field field--error"
                                                : "field"
                                        }
                                        id="author_name"
                                        name="author_name"
                                        placeholder="Voornaam Achternaam"
                                        aria-invalid={errors.author_name && touched.author_name ? 'true' : null}
                                        aria-describedby={errors.author_name && touched.author_name ? 'author_name_error' : null}
                                        aria-required="true"
                                        autoComplete="name"
                                    />
                                    <div role="status">
                                        <ErrorMessage name="author_name">
                                            {msg => (
                                                <div className="field__error-message" id="author_name_error">
                                                    {msg}
                                                </div>
                                            )}
                                        </ErrorMessage>
                                    </div>
                                </div>
                            </div>

                            <div className="field__row">
                                <label
                                    htmlFor="author_email"
                                    className="field__label"
                                >
                                    Uw e-mailadres *
                                </label>
                                <div className="field__wrapper">
                                    <Field
                                        className={
                                            errors.author_email &&
                                            touched.author_email
                                                ? "field field--error"
                                                : "field"
                                        }
                                        type="email"
                                        id="author_email"
                                        name="author_email"
                                        placeholder="mail@example.com"
                                        aria-invalid={errors.author_email && touched.author_email ? 'true' : null}
                                        aria-describedby={errors.author_email && touched.author_email ? 'author_email_error' : null}
                                        aria-required="true"
                                        autoComplete="email"
                                    />
                                    <div role="status">
                                        <ErrorMessage name="author_email">
                                            {msg => (
                                                <div className="field__error-message" id="author_email_error">
                                                    {msg}
                                                </div>
                                            )}
                                        </ErrorMessage>
                                    </div>
                                </div>
                            </div>

                            <div className="field__row">
                                <label
                                    htmlFor="author_organization"
                                    className="field__label"
                                >
                                    Organisatie
                                </label>
                                <div className="field__wrapper">
                                    <Field
                                        className={
                                            errors.author_organization &&
                                            touched.author_organization
                                                ? "field field--error"
                                                : "field"
                                        }
                                        type="text"
                                        id="author_organization"
                                        name="author_organization"
                                        placeholder="Bedrijfsnaam"
                                        aria-describedby={errors.author_organization && touched.author_organization ? 'author_organization_error' : null}
                                        autoComplete="organization"
                                    />
                                    <ErrorMessage name="author_organization">
                                        {msg => (
                                            <div className="field__error-message" id="author_organization_error">
                                                {msg}
                                            </div>
                                        )}
                                    </ErrorMessage>
                                </div>
                            </div>

                            <div className="field__row">
                                <label
                                    htmlFor="item_type"
                                    className="field__label"
                                >
                                    Soort advertentie *
                                </label>

                                <div className="field__wrapper">
                                    <div className="form__radio-group">
                                        <label>
                                            <Field
                                                id="item_type"
                                                name="item_type"
                                                value="offer"
                                                type="radio"
                                            />
                                            Aangeboden
                                        </label>
                                        <label>
                                            <Field
                                                id="item_type"
                                                name="item_type"
                                                value="wanted"
                                                type="radio"
                                            />
                                            Gezocht
                                        </label>
                                    </div>
                                    <ErrorMessage name="item_type">
                                        {msg => (
                                            <div className="field__error-message">
                                                {msg}
                                            </div>
                                        )}
                                    </ErrorMessage>
                                </div>
                            </div>

                            <div className="field__row">
                                <label htmlFor="title" className="field__label">
                                    Titel van uw advertentie *
                                </label>
                                <div className="field__wrapper">
                                    <Field
                                        className={
                                            errors.title && touched.title
                                                ? "field field--error"
                                                : "field"
                                        }
                                        id="title"
                                        name="title"
                                        placeholder="Titel"
                                        aria-invalid={errors.title && touched.title ? 'true' : null}
                                        aria-describedby={errors.title && touched.title ? 'title_error' : null}
                                        aria-required="true"
                                    />
                                    <div role="status">
                                        <ErrorMessage name="title">
                                            {msg => (
                                                <div className="field__error-message" id="title_error">
                                                    {msg}
                                                </div>
                                            )}
                                        </ErrorMessage>
                                    </div>
                                </div>
                            </div>

                            <div className="field__row">
                                <label
                                    htmlFor="content_textarea"
                                    className="field__label"
                                >
                                    Omschrijving van de advertentie *
                                </label>
                                <div className="field__wrapper">
                                    <Field
                                        className={
                                            errors.content && touched.content
                                                ? "field field--error"
                                                : "field"
                                        }
                                        component="textarea"
                                        id="content_textarea"
                                        name="content"
                                        placeholder="Omschrijving"
                                        aria-invalid={errors.content && touched.content ? 'true' : null}
                                        aria-describedby={errors.content && touched.content ? 'content_error' : null}
                                        aria-required="true"
                                    />
                                    <div role="status">
                                        <ErrorMessage name="content">
                                            {msg => (
                                                <div className="field__error-message" id="content_error">
                                                    {msg}
                                                </div>
                                            )}
                                        </ErrorMessage>
                                    </div>
                                </div>
                            </div>

                            <div className="field__row">
                                <label htmlFor="city" className="field__label">
                                    Plaats *
                                </label>
                                <div className="field__wrapper">
                                    <Field
                                        id="city"
                                        name="city"
                                        multiple={true}
                                        isClearable={true}
                                        className={
                                            errors.city && touched.city
                                                ? "field__select field__select--error"
                                                : "field__select"
                                        }
                                        placeholder="Selecteer één of meerdere plaatsen"
                                        component={SelectField}
                                        options={this.renderCitiesOptions()}
                                        aria-invalid={errors.city && touched.city ? 'true' : null}
                                        aria-describedby={errors.city && touched.city ? 'city_error' : null}
                                    ></Field>
                                    <div role="status">
                                        {errors.city && touched.city ? (
                                            <div className="field__error-message" id="city_error">
                                                {errors.city}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <div className="field__row">
                                <label
                                    htmlFor="target_audience"
                                    className="field__label"
                                >
                                    Doelgroep
                                </label>
                                <div className="field__wrapper">
                                    <Field
                                        id="target_audience"
                                        name="target_audience"
                                        multiple={true}
                                        isClearable={true}
                                        className={
                                            errors.target_audience &&
                                            touched.target_audience
                                                ? "field__select field__select--error"
                                                : "field__select"
                                        }
                                        placeholder="Selecteer een doelgroep"
                                        component={SelectField}
                                        onBlur={() => {
                                            setFieldTouched("city", true);
                                        }}
                                        options={this.renderTargetAudienceOptions()}
                                        aria-describedby={errors.target_audience && touched.target_audience ? 'target_audience_error' : null}
                                    ></Field>

                                    <ErrorMessage name="target_audience">
                                        {msg => (
                                            <div className="field__error-message" id="target_audience_error">
                                                {msg}
                                            </div>
                                        )}
                                    </ErrorMessage>
                                </div>
                            </div>

                            {this.props.vogMessage !== null ? (
                                <div className="field__row field--information">
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.vogMessage
                                        }}
                                    ></p>
                                </div>
                            ) : null}

                            {isValid ? (
                                <GoogleReCaptcha
                                    onVerify={this.handleRecaptchaVerify}
                                ></GoogleReCaptcha>
                            ) : null}

                            <div className="buttons">
                                <button
                                    className="button button--primary button--small"
                                    type="submit"
                                    disabled={!isValid}
                                >
                                    {this.state.isLoading
                                        ? "Versturen..."
                                        : "Plaats de advertentie"}
                                </button>
                                <button
                                    className="button button--secondary button--small"
                                    type="reset"
                                    onClick={e => {
                                        window.open(
                                            this.props.archivePageUrl,
                                            "_self"
                                        );
                                    }}
                                >
                                    Annuleren
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        );
    }
}
